export const ANY_ANSWER = '*';
